import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../../redux/store";
import "./UserSelect.css"
import React, {useEffect, useState} from "react";
import RootState from "../../../redux/states/root.state";
import { CircularProgress, Pagination, Button, TextField, Checkbox, FormControlLabel, Link, List, ListItem, ListItemButton, ListItemText, ListItemIcon, Chip, Box, Typography } from "@mui/material";
import {fetchDealershipStaff, fetchDealershipUsers} from "../../../redux/actions/dealership.actions";
import { fetchRoleUsers } from "../../../redux/actions/roles.actions";
import { useNavigate } from "react-router-dom";

interface UserSelectProps {
    checked:any[];
    setChecked: any;
    dealership_id:any;
    role?:string;}

const MultiSelectUserRole: React.FC<UserSelectProps> = ({
    checked,
    setChecked,
    dealership_id,
    role='sales',
}) => {
const dispatch: AppDispatch = useDispatch();
const {data:users,meta,loading} = useSelector((state: RootState) => state.roleUsers);
const navigate = useNavigate();
const [pageNumber, setPageNumber] = useState(1);
const [email, setEmail] = useState(``);
const [emailQuery, setEmailQuery] = useState<any>(null);

const handleCheck = (user:any) => {
    let newArr = [...checked];
    let found = checked?.find((checked_user:any)=>user?.id===checked_user?.id)!==undefined;
    if(found){
      newArr = newArr.filter((checked_user:any)=>checked_user?.id!==user?.id);
    } else {
      newArr.push(user);
    }
    setChecked(newArr);
}

useEffect(() => {
    let page = `page=${pageNumber}`;
    if (emailQuery) {
        page += `&email=${emailQuery}`
    }
    if (dealership_id) {
        dispatch(fetchDealershipStaff({id:dealership_id,params:page+`&role=${role}`}))
    }
  }, [dispatch,pageNumber,dealership_id, role, emailQuery]);

  return (
    <>
    <div className="user-search-container">
        <TextField type="search" placeholder="Search email..." onChange={(e)=>setEmail(e.target.value)} size="small" fullWidth/>
        <Button type="button" variant="contained" onClick={()=>setEmailQuery(email)} size="small">Search</Button>
    </div>

        { loading ?
    <div className="no-users"><CircularProgress size={"24px"}/></div>
    :
    users.length>0 ? 
        <div className="select-container">
            <List 
                dense
                sx={{
                    maxHeight: 200,
                    overflow: 'auto',
                    '&::-webkit-scrollbar': {
                        width: '8px',
                    },
                    '&::-webkit-scrollbar-track': {
                        backgroundColor: 'rgba(0,0,0,0.1)',
                        borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: 'rgba(0,0,0,0.3)',
                        borderRadius: '4px',
                        '&:hover': {
                            backgroundColor: 'rgba(0,0,0,0.5)',
                        },
                    },
                }}
            >
                {users.map((user: any) => (
                    <ListItem key={user.id} disablePadding>
                        <ListItemButton
                            onClick={() => handleCheck(user)}
                            selected={checked.some(c => c.id === user.id)}
                            sx={{ borderRadius: 1 }}
                        >
                            <ListItemIcon>
                                <Checkbox 
                                    checked={checked.some(c => c.id === user.id)}
                                    size="small"
                                />
                            </ListItemIcon>
                            <ListItemText
                                primary={
                                    <Box display="flex" alignItems="center" gap={1}>
                                        <Chip 
                                            label={user?.roles[0]?.name ?? 'customer'} 
                                            size="small" 
                                            color="primary" 
                                            variant="outlined"
                                        />
                                        <Typography variant="body2">
                                            {user?.name !== '' ? `${user?.name} (${user?.email})` : user?.email}
                                        </Typography>
                                    </Box>
                                }
                            />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
            {meta?.last_page>1 && <Pagination 
                count={meta?.last_page} 
                size="small"
                onChange={(e,page)=>setPageNumber(page)}
                page={pageNumber}
                showLastButton 
                showFirstButton 
                disabled={meta?.last_page===1}
            />}
        </div>
        :
        <div className="no-users">
            <p>No users found.</p>
            <Link 
                href="/users"
                onClick={e => {
                e.preventDefault();
                navigate('/users');
                }}>View all users</Link>
        </div>
        }
    </>
  );
};

export default MultiSelectUserRole;
